import PropTypes from "prop-types"
import classNames from "classnames"
import { AutoAwesome } from "@mui/icons-material"
import Button from "components/material/button"

export function ToggleButton({ size, className, disabled, tooltip, onClick, twinkle = false }) {
  return (
    <Button
      onClick={onClick}
      size={size}
      color="primary"
      variant="contained"
      className={classNames("ai-toggle-button", { "ai-toggle-button--twinkle": twinkle }, className)}
      disabled={disabled}
      tooltip={tooltip}
    >
      <AutoAwesome className="ai-toggle-button-icon" fontSize="inherit" />
    </Button>
  )
}

ToggleButton.propTypes = {
  size: PropTypes.oneOf(["small", "medium"]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  // When true, the button twinkles without hover (drives the discoverability nudge).
  twinkle: PropTypes.bool,
}
